import { _MustMatchServerStrings, ConfigSystemParams, msSize } from 'src/app/core/consts';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, throwError } from 'rxjs';
import { CommConfigService } from 'src/app/core/services/utelize/system/communication/comm-config-service';
import { CommunicationTemplateDTO } from 'src/app/core/models/system/communication/communication-template.dto';
import { CommunicationTemplateReplacements } from 'src/app/core/models/system/communication/communication-template-replacements';
import { CommunicationTemplatesDefaultsDTO } from 'src/app/core/models/system/communication/communication-templates-defaults.dto';
import { CompletedModalFormComponent } from '../_pop-ups/completed-modal-form/completed-modal-form.component';
import { Component, EventEmitter, HostListener, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DeliveryType, TemplateModalAction } from 'src/app/core/enums';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { InputModalFormComponent } from 'src/app/forms-modal/_inputs/input-form/input-modal-form.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { ValidatorService } from 'src/app/core/services/utelize/general/validator-service';

@Component({
  selector: 'app-template-email-modal-form',
  templateUrl: './template-email-modal-form.component.html',
  styleUrls: ['./template-email-modal-form.component.scss']
})
export class TemplateEmailModalFormComponent {
  public ccMaxLength        = 1000;
  public bccMaxLength       = 1000;
  public fromEmailMaxLength = 255;
  public formTitle          = 'Email Template';
  public toEmailMaxLength   = 1000;

  public readonly smsOnlySubject = _MustMatchServerStrings.SmsOnlyTemplateSubject;

  @Input() bodyOnly        : boolean | undefined;
  @Input() embeddedFormMode: boolean | undefined;
  @Input() label0Text      : string  | undefined;
  @Input() title           : string  | undefined;
  @Input() updateMessage   : string  | undefined;

  @Output() companyDefaultsUpdated       : EventEmitter<void> = new EventEmitter<void>();
  @Output() emailTemplateModalFormClosed : EventEmitter<{TemplateModalAction : TemplateModalAction,TemplateId : number}> = new EventEmitter<{TemplateModalAction : TemplateModalAction,TemplateId : number}>();
  
  @ViewChild('completedModalForm',      { static: false }) completedModalForm!: CompletedModalFormComponent;
  @ViewChild('inputModalForm',          { static: false }) inputModalForm!    : InputModalFormComponent;
  @ViewChild('messageTextArea',         { static: false }) messageTextArea!   : HTMLTextAreaElement;
  @ViewChild('subjectTextArea',         { static: false }) subjectTextArea!   : HTMLTextAreaElement;
  @ViewChild('templateModalForm',       { static: false }) templateModalForm! : TemplateRef<void>;
  
  get canEditTemplate () { return this.authenticationService.canEditSystemOwned(this.template?.systemOwned ?? false); }

  get modalBackGround () {  let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                            return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false)       }
  get hideFromOptions() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.CommunicationTemplatesHideFromOptions, true ); }

  private curUser                     : SystemUserDTO;
  private selectedTemplateReplacement!: CommunicationTemplateReplacements;
  private sureSimCompanyId            : number | undefined;
  private templateModalFormRef!       : NgbModalRef;

  public alreadyEnabled               : boolean = false;
  public communicationTypeIdData      : IdAndDescriptionDTO[]=[];
  public companyDefaults!             : CommunicationTemplatesDefaultsDTO;
  public genericComposeMode           : boolean = false;
  public hideMessageType              : boolean = false;
  public hideSaveAndEnable            : boolean = false;
  public hideSubject                  : boolean = false;
  public lastMouseEvent               : MouseEvent | undefined;
  public lastSystemValueTarget        : HTMLInputElement | HTMLTextAreaElement | undefined;
  public messageType                  : string = '';
  public onlyShowBody                 : boolean = false;
  public saveAllocation               : boolean = false;
  public showElsewhereMessage         : boolean = false;
  public selectedTemplateReplacementId: number = 0;
  public template!                    : CommunicationTemplateDTO;
  public templateForm!                : UntypedFormGroup;
  public templateFormSubmitted        : boolean = false;
  public templateModalAction          : TemplateModalAction = TemplateModalAction.Cancel;
  public templateReplacements         : CommunicationTemplateReplacements[] = [];
  public templateReplacementsValues : {name:string, id:number}[] = [];
  
  constructor(
    private authenticationService : AuthenticationService,
    private commConfigService     : CommConfigService,
    private configSystemService   : ConfigSystemService,
    private exceptionsService     : ExceptionsService,
    private formBuilder           : UntypedFormBuilder,
    private modalService          : NgbModal,
    private validatorService      : ValidatorService
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public inputModalFormSubmitted(inputValue: string) {
    try {
      if (this.inputModalForm.formTitle == "Insert System Value") {
        let selectedSystemValue = this.templateReplacements.find(x => x.id == Number(inputValue));
        if(selectedSystemValue){
          this.insertTextAtCursor(<HTMLTextAreaElement>this.lastSystemValueTarget, selectedSystemValue.placeHolder ?? "");
        }
      } else {
        if (this.inputModalForm.formTitle        == "BCC Default") {
          this.companyDefaults.bcc = inputValue;
        } else if (this.inputModalForm.formTitle == "CC Default") {
          this.companyDefaults.cc = inputValue;
        } else if (this.inputModalForm.formTitle == "From Email Default") {
          this.companyDefaults.fromEmail = inputValue;
        } else if (this.inputModalForm.formTitle == "Send Elsewhere Default") {
          this.companyDefaults.toEmail = inputValue;
        }
          this.updateCompanyDefaults();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public updateCompanyDefaults(): void {
    try {
      this.commConfigService.createCompanyCommunicationTemplateDefaults({
        BCC       : this.companyDefaults.bcc,
        CC        : this.companyDefaults.cc,
        CompanyId : this.sureSimCompanyId,
        EnteredBy : this.curUser.userId,
        FromEmail : this.companyDefaults.fromEmail,
        FromNumber: this.companyDefaults.fromNumber,
        ToEmail   : this.companyDefaults.toEmail,
        ToNumber  : this.companyDefaults.toNumber,
      })
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.companyDefaultsUpdated.emit();
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });

        this.companyDefaultsUpdated.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public handleMouseClick(event: MouseEvent): void {
    try {
      if (event.ctrlKey) {
        this.lastMouseEvent       =event;
        this.lastSystemValueTarget=<HTMLInputElement | HTMLTextAreaElement>event.target;
        this.openSystemValuePicker();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public handleKeyUp(event: KeyboardEvent): void {
    try {
      const target=<HTMLInputElement | HTMLTextAreaElement>event.target;

      if (!target || (target.tagName != 'INPUT' && target.tagName != 'TEXTAREA'))
        return;

      const caret=target.selectionStart ?? 0;

      if (caret<2 || target.value.substring(caret-2, caret) != '@@')
        return;

      const before=target.value.substring(0, caret-2);
      const after =target.value.substring(caret);

      target.value=before+after;
      target.setSelectionRange(caret-2, caret-2);
      target.dispatchEvent(new Event('input'));

      this.lastMouseEvent       =undefined;
      this.lastSystemValueTarget=target;
      this.openSystemValuePicker();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openSystemValuePicker(): void {
    try {
      this.inputModalForm.fieldCaption                        ="System Value";
      this.inputModalForm.formTitle                           ="Insert System Value";
      this.inputModalForm.input0EnforceMaxLengthValidation    =false;
      this.inputModalForm.input0EnforceMultipleEmailValidation=false;
      this.inputModalForm.input0EnforceRequiredValidation     =false;
      this.inputModalForm.input0Value                         =undefined;
      this.inputModalForm.input0Values                        =this.templateReplacementsValues;
      this.inputModalForm.openForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public insertTextAtCursor(textArea: HTMLTextAreaElement, text: string): void {
    try {
      const start    = textArea.selectionStart;
      const end      = textArea.selectionEnd;
    
      // Insert the text at the cursor position
      const before   = textArea.value.substring(0, start);
      const after    = textArea.value.substring(end);
      textArea.value = before + text + after;
    
      // Move the cursor to the end of the inserted text
      const cursorPosition = start + text.length;
      textArea.setSelectionRange(cursorPosition, cursorPosition);
    
      // Trigger change detection if needed
      textArea.dispatchEvent(new Event('input'));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy() {
    this.closeForm(this.templateModalAction);
  }

  public closeForm(action: TemplateModalAction): void {
    try {
      this.emailTemplateModalFormClosed.emit({TemplateModalAction:action, TemplateId:this.template?.id ?? -1});
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  get formData() {
    return this.templateForm.controls;
  }

  public openForm(messageType       : string,                            template               : CommunicationTemplateDTO,
                  companyId         : number,                            templateReplacements   : CommunicationTemplateReplacements[],
                  companyDefaults   : CommunicationTemplatesDefaultsDTO, alreadyEnabled         : boolean,
                  saveAllocation    : boolean=true,                      hideMessageType        : boolean=false,
                  hideSaveAndEnable : boolean=false,                     onlyShowBody           : boolean=false,
                  genericComposeMode: boolean=false,                     communicationTypeIdData: IdAndDescriptionDTO[]=[]): void {
    try {
      this.alreadyEnabled             = alreadyEnabled;
      this.communicationTypeIdData    = communicationTypeIdData;
      this.companyDefaults            = companyDefaults;
      this.genericComposeMode         = genericComposeMode;
      this.hideMessageType            = hideMessageType;
      this.hideSaveAndEnable          = hideSaveAndEnable;
      this.messageType                = messageType;
      this.onlyShowBody               = onlyShowBody;
      this.saveAllocation             = saveAllocation;
      this.showElsewhereMessage       = template.sendElsewhere ?? false;
      this.sureSimCompanyId           = companyId;
      this.template                   = template;
      this.templateFormSubmitted      = false;
      this.templateModalAction        = TemplateModalAction.Cancel;
      this.templateReplacements       = templateReplacements;
      this.templateReplacementsValues = this.templateReplacements.map(item => ({  name: item.columnName ?? "", id: item.id }))

      this.openModal();
      this.setUpForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private subjectForSave(): string {
    try {
      if (this.hideSubject)
        return this.smsOnlySubject;

      return this.template.subject ?? "";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  private reflectChanges(): void {
    try{
      this.template.name               =this.formData['templateName'       ].value;
      this.template.communicationTypeId=this.formData['communicationTypeId'].value;
      this.template.subject            =this.formData['subject'            ].value;
      this.template.body               =this.formData['message'            ].value;
      this.template.fromEmail          =this.formData['fromEmail'          ].value;   
      this.template.toEmail            =this.formData['toEmail'            ].value;
      this.template.sendElsewhere      =this.formData['sendElsewhere'      ].value;   
      this.template.sendToUser         =this.formData['sendToUser'         ].value;      
      this.template.useDefaultFromEmail=this.formData['useDefaultFromEmail'].value;
      this.template.useDefaultBCC      =this.formData['useDefaultBCC'      ].value;     
      this.template.useDefaultCC       =this.formData['useDefaultCC'       ].value; 
      this.template.useDefaultToEmail  =this.formData['useDefaultToEmail'  ].value;     
      this.template.cc                 =this.formData['cc'                 ].value;                
      this.template.bcc                =this.formData['bcc'                ].value;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.removeFormFields(this.templateForm);
      this.templateForm = this.formBuilder.group({ });
      this.addFormFields(this.templateForm);

      this.populateFormFields();
      // this.templateForm.valueChanges.subscribe(changedValues => {
      //   this.reflectChanges();
      //   if(this.templateForm.controls['useDefaultFromEmail']){
      //     if(this.templateForm.controls['useDefaultFromEmail'].value){
      //     this.templateForm.controls['fromEmail']?.disable({ emitEvent: false });
      //     } else{
      //       this.templateForm.controls['fromEmail']?.enable({ emitEvent: false });
      //     }
      //   }

      //   if(this.templateForm.controls['useDefaultCC']){
      //     if(this.templateForm.controls['useDefaultCC'].value){
      //       this.templateForm.controls['cc']?.disable({ emitEvent: false });
      //     } else{
      //       this.templateForm.controls['cc']?.enable({ emitEvent: false });
      //     }
      //   }
        
      //   if(this.templateForm.controls['useDefaultBCC']){
      //     if(this.templateForm.controls['useDefaultBCC'].value){
      //       this.templateForm.controls['bcc']?.disable({ emitEvent: false });
      //     } else{
      //       this.templateForm.controls['bcc']?.enable({ emitEvent: false });
      //     }
      //   }
        
      //});
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private populateFormFields() {
    try {
      if (this.templateForm != undefined) {
        this.templateForm.controls["templateName"       ].setValue(this.template.name);
        this.templateForm.controls["communicationTypeId"].setValue(this.template.communicationTypeId);
        this.templateForm.controls["message"            ].setValue(this.template.body);
        this.templateForm.controls["fromEmail"          ].setValue(this.template.fromEmail);
        this.templateForm.controls["cc"                 ].setValue(this.template.cc);
        this.templateForm.controls["bcc"                ].setValue(this.template.bcc);
        this.templateForm.controls["sendToUser"         ].setValue(this.template.sendToUser ?? true);
        this.templateForm.controls["sendElsewhere"      ].setValue(this.template.sendElsewhere ?? false);
        this.templateForm.controls["subject"            ].setValue(this.template.subject==this.smsOnlySubject ? undefined : this.template.subject);
        this.templateForm.controls["toEmail"            ].setValue(this.template.toEmail ?? "");
        this.templateForm.controls["useDefaultBCC"      ].setValue(this.template.useDefaultBCC);
        this.templateForm.controls["useDefaultCC"       ].setValue(this.template.useDefaultCC);
        this.templateForm.controls["useDefaultFromEmail"].setValue(this.template.useDefaultFromEmail || this.hideFromOptions);  
        this.templateForm.controls["useDefaultToEmail"  ].setValue(this.template.useDefaultToEmail ?? false);          
      }        
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      this.addFormControl(formGroup, "templateName",        this.template.name                   , [Validators.required]);
      this.addFormControl(formGroup, "communicationTypeId", this.template.communicationTypeId    , []);
      this.addFormControl(formGroup, "message",             this.template.body                   , [Validators.required]);
      this.addFormControl(formGroup, "fromEmail",           this.template.fromEmail              , this.genericComposeMode ? [] : [this.validatorService.emailValidator.bind(this.validatorService)]);
      this.addFormControl(formGroup, "toEmail",             this.template.toEmail ?? ""          , this.genericComposeMode ? [] : [this.validatorService.multipleEmailValidator.bind(this.validatorService)]);
      this.addFormControl(formGroup, "sendToUser",          this.template.sendToUser ?? false    , this.genericComposeMode ? [] : [Validators.required]);
      this.addFormControl(formGroup, "sendElsewhere",       this.template.sendElsewhere ?? false , this.genericComposeMode ? [] : [Validators.required]);
      this.addFormControl(formGroup, "subject",             this.template.subject                , this.hideSubject        ? [] : [Validators.required]);
      this.addFormControl(formGroup, "useDefaultFromEmail", this.template.useDefaultFromEmail    , this.genericComposeMode ? [] : [Validators.required]);
      this.addFormControl(formGroup, "useDefaultBCC",       this.template.useDefaultBCC          , this.genericComposeMode ? [] : [Validators.required]);
      this.addFormControl(formGroup, "useDefaultCC",        this.template.useDefaultCC           , this.genericComposeMode ? [] : [Validators.required]);
      this.addFormControl(formGroup, "useDefaultToEmail",   this.template.useDefaultToEmail ?? "", this.genericComposeMode ? [] : [Validators.required]);
      this.addFormControl(formGroup, "cc",                  this.template.cc                     , this.genericComposeMode ? [] : [this.validatorService.multipleEmailValidator.bind(this.validatorService)]);
      this.addFormControl(formGroup, "bcc",                 this.template.bcc                    , this.genericComposeMode ? [] : [this.validatorService.multipleEmailValidator.bind(this.validatorService)]);
      if(this.template.useDefaultFromEmail){
        formGroup.get('fromEmail')?.disable({ emitEvent: false });
      } else{
        formGroup.get('fromEmail')?.enable({ emitEvent: false });
      }

      if(this.template.sendElsewhere) {
        if(this.template.useDefaultToEmail){
          formGroup.get('toEmail')?.disable({ emitEvent: false });
        } else{
          formGroup.get('toEmail')?.enable({ emitEvent: false });
        }
      } else {
          formGroup.get('toEmail')?.disable({ emitEvent: false });
          formGroup.get('useDefaultToEmail')?.disable({ emitEvent: false });
      }

      if(this.template.useDefaultCC){
        formGroup.get('cc')?.disable({ emitEvent: false });
      } else{
        formGroup.get('cc')?.enable({ emitEvent: false });
      }

      if(this.template.useDefaultBCC){
        formGroup.get('bcc')?.disable({ emitEvent: false });
      } else{
        formGroup.get('bcc')?.enable({ emitEvent: false });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | number | string | undefined,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openModal(): void {
    try {
      this.templateModalFormRef = this.modalService.open(this.templateModalForm, 
        { 
          backdrop: this.modalBackGround, 
          centered: true,
          keyboard: false,
          size    : msSize.Large 
        });
    }
    catch(e) {
      this.emailTemplateModalFormClosed.emit({TemplateModalAction:TemplateModalAction.Cancel, TemplateId:this.template.id});
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public editBCCDefault(): void {
    try {
      this.lastMouseEvent = undefined;

      this.inputModalForm.fieldCaption                        ="Value";
      this.inputModalForm.formTitle                           ="BCC Default";
      this.inputModalForm.input0EnforceMaxLengthValidation    =true;
      this.inputModalForm.input0EnforceMultipleEmailValidation=true;
      this.inputModalForm.input0EnforceRequiredValidation     =true;
      this.inputModalForm.input0Value                         =this.companyDefaults.bcc;
      this.inputModalForm.input0Values                        =undefined;
      this.inputModalForm.openForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public editCCDefault(): void {
    try {
      this.lastMouseEvent = undefined;

      this.inputModalForm.fieldCaption                        ="Value";
      this.inputModalForm.formTitle                           ="CC Default";
      this.inputModalForm.input0EnforceMaxLengthValidation    =true;
      this.inputModalForm.input0EnforceMultipleEmailValidation=true;
      this.inputModalForm.input0EnforceRequiredValidation     =true;
      this.inputModalForm.input0Value                         =this.companyDefaults.cc;
      this.inputModalForm.input0Values                        =undefined;
      this.inputModalForm.openForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public editFromEmailDefault(): void {
    try {
      this.lastMouseEvent = undefined;

      this.inputModalForm.fieldCaption                        ="Value";
      this.inputModalForm.formTitle                           ="From Email Default";
      this.inputModalForm.input0EnforceMaxLengthValidation    =true;
      this.inputModalForm.input0EnforceMultipleEmailValidation=true;
      this.inputModalForm.input0EnforceRequiredValidation     =true;
      this.inputModalForm.input0Value                         =this.companyDefaults.fromEmail;
      this.inputModalForm.input0Values                        =undefined;
      this.inputModalForm.openForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public editSendElsewhereDefault(): void {
    try {
      this.lastMouseEvent = undefined;

      this.inputModalForm.fieldCaption                        ="Value";
      this.inputModalForm.formTitle                           ="Send Elsewhere Default";
      this.inputModalForm.input0EnforceMaxLengthValidation    =true;
      this.inputModalForm.input0EnforceMultipleEmailValidation=true;
      this.inputModalForm.input0EnforceRequiredValidation     =true;
      this.inputModalForm.input0Value                         =this.companyDefaults.toEmail;
      this.inputModalForm.input0Values                        =undefined;
      this.inputModalForm.openForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onDefaultBCCChange(): void {
    try {
      if(this.formData['useDefaultBCC'].value) {
      this.templateForm.controls["bcc"].setValue('');
        this.templateForm.get('bcc')?.disable({ emitEvent: false });
      } else{
        this.templateForm.get('bcc')?.enable({ emitEvent: false });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onDefaultCCChange(): void {
    try {
      if(this.formData['useDefaultCC'].value) {
        this.templateForm.controls["cc"].setValue('');
        this.templateForm.get('cc')?.disable({ emitEvent: false });
      } else{
        this.templateForm.get('cc')?.enable({ emitEvent: false });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onDefaultFromEmailChange(): void {
    try {
      if(this.formData['useDefaultFromEmail'].value) {
        this.templateForm.controls["fromEmail"].setValue('');
        this.templateForm.get('fromEmail')?.disable({ emitEvent: false });
      } else{
        this.templateForm.get('fromEmail')?.enable({ emitEvent: false });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onDefaultToEmailChange(): void {
    try {
      if(this.formData['useDefaultToEmail'].value) {
        this.templateForm.controls["toEmail"].setValue('');
        this.templateForm.get('toEmail')?.disable({ emitEvent: false });
      } else{
        this.templateForm.get('toEmail')?.enable({ emitEvent: false });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onSendElsewhereChange(): void {
    try {
      this.showElsewhereMessage = this.formData['sendElsewhere'].value;
      if(this.formData['sendElsewhere'].value){
        this.templateForm.get('useDefaultToEmail')?.enable({ emitEvent: false });
        if(this.formData['useDefaultToEmail'].value) {
            this.templateForm.get('toEmail')?.disable({ emitEvent: false });
          } else{
            this.templateForm.get('toEmail')?.enable({ emitEvent: false });
          }
      } else{
        this.templateForm.controls["toEmail"].setValue('');
        this.templateForm.controls["useDefaultToEmail"].setValue(false);
        this.templateForm.get('toEmail')?.disable({ emitEvent: false });
        this.templateForm.get('useDefaultToEmail')?.disable({ emitEvent: false });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onSendToUserChange(): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public saveAndEnable() {
    try {
      this.reflectChanges();
      this.templateFormSubmitted=true;

      if (this.templateForm.valid) {
        let saveBody = {
          AlertTypeId         : this.template.alertTypeId,
          ID                  : this.template.id,
          CommunicationTypeId : this.template.communicationTypeId,
          CompanyId           : this.sureSimCompanyId,
          DeliveryTypeId      : DeliveryType.Email,
          MessageTypeId       : this.template.messageTypeId,
          Name                : this.template.name,
          Subject             : this.subjectForSave(),
          Body                : this.template.body,
          CC                  : this.template.cc,
          BCC                 : this.template.bcc,
          FromEmail           : this.template.fromEmail,
          FromNumber          : this.template.fromNumber,
          SendElsewhere       : this.template.sendElsewhere,
          SendToUser          : this.template.sendToUser,
          ToEmail             : this.template.toEmail,
          ToNumber            : this.template.toNumber,
          UseDefaultCC        : this.template.useDefaultCC,
          UseDefaultBCC       : this.template.useDefaultBCC,
          UseDefaultFromEmail : this.template.useDefaultFromEmail,
          UseDefaultFromNumber: this.template.useDefaultFromNumber,
          UseDefaultToEmail   : this.template.useDefaultToEmail,
          UseDefaultToNumber  : this.template.useDefaultToNumber,
          EnteredBy           : this.curUser.userId,
          Active              : true,
          Deleted             : false,
          SystemOwned         : false
        };
        let enableBody = {
          TemplateId      : this.template.id,
          CompanyId       : this.sureSimCompanyId,
          DeliveryTypeId  : DeliveryType.Email,
          MessageTypeId   : this.template.messageTypeId,
          EnteredBy       : this.curUser.userId
        };
        if(this.template.id > 0){
          this.commConfigService.editCommunicationTemplate(saveBody).subscribe(id => {
            if (this.saveAllocation) {
            this.commConfigService.enableCompanyTemplate(enableBody).subscribe(y => {
              this.templateModalAction = TemplateModalAction.SaveAndEnable;
              this.completedModalForm.openForm("Congratulations",  this.updateMessage != undefined ? this.updateMessage : "Template has been updated and enabled.");
            });
          } else {
            this.templateModalAction = TemplateModalAction.SaveAndEnable;
            this.completedModalForm.openForm("Congratulations",  this.updateMessage != undefined ? this.updateMessage : "Template has been updated and enabled.");
          }
          });
        }
        else{
          this.commConfigService.createCommunicationTemplate(saveBody).subscribe(id => {
            enableBody.TemplateId = id;
            this.template.id      = id;
            if (this.saveAllocation) {
            this.commConfigService.enableCompanyTemplate(enableBody).subscribe(y => {
              this.templateModalAction = TemplateModalAction.SaveAndEnable;
              this.completedModalForm.openForm("Congratulations",  this.updateMessage != undefined ? this.updateMessage : "Template has been created and enabled.");
            });
          } else {
            this.templateModalAction = TemplateModalAction.SaveAndEnable;
            this.completedModalForm.openForm("Congratulations",  this.updateMessage != undefined ? this.updateMessage : "Template has been created and enabled.");
          }
          })
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public save() {
    try {
        this.reflectChanges();
        this.templateFormSubmitted=true;

        if (this.templateForm.valid) {
          let saveBody = {
            AlertTypeId         : this.template.alertTypeId,
            ID                  : this.template.id,
            CommunicationTypeId : this.template.communicationTypeId,
            CompanyId           : this.sureSimCompanyId,
            DeliveryTypeId      : DeliveryType.Email,
            MessageTypeId       : this.template.messageTypeId,
            Name                : this.template.name,
            Subject             : this.subjectForSave(),
            Body                : this.template.body,
            CC                  : this.template.cc,
            BCC                 : this.template.bcc,
            FromEmail           : this.template.fromEmail,
            FromNumber          : this.template.fromNumber,
            SendToUser          : this.template.sendToUser,
            SendElsewhere       : this.template.sendElsewhere,
            ToEmail             : this.template.toEmail,
            ToNumber            : this.template.toNumber,
            UseDefaultCC        : this.template.useDefaultCC,
            UseDefaultBCC       : this.template.useDefaultBCC,
            UseDefaultFromEmail : this.template.useDefaultFromEmail,
            UseDefaultFromNumber: this.template.useDefaultFromNumber,
            UseDefaultToEmail   : this.template.useDefaultToEmail,
            UseDefaultToNumber  : this.template.useDefaultToNumber,
            EnteredBy           : this.curUser.userId,
            Active              : true,
            Deleted             : false,
            SystemOwned         : false
          };
          
          if(this.template.id > 0){
            this.commConfigService.editCommunicationTemplate(saveBody).subscribe({
              next : x => {
                this.templateModalAction = TemplateModalAction.Save;
                this.completedModalForm.openForm("Congratulations",  this.updateMessage != undefined ? this.updateMessage : "Template has been updated.");
              },
              error: error => { this.exceptionsService.handleException(new Error("TemplateEmailModalFormComponent.save() - The template could not be updated: " + error)); }
            });
          }
          else{
            this.commConfigService.createCommunicationTemplate(saveBody).subscribe({
              next : id    => {
                                this.template.id         = id;
                                this.templateModalAction = TemplateModalAction.Save;
                                this.completedModalForm.openForm("Congratulations",  this.updateMessage != undefined ? this.updateMessage : "Template has been created.");
                              },
              error: error => { this.exceptionsService.handleException(new Error("TemplateEmailModalFormComponent.save() - The template could not be created: " + error)); }
            });
          }  
        }    
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public completedModalHasBeenClosed() {
    this.closeForm(this.templateModalAction);
    this.templateModalFormRef.close('Close click');
  }
 
  public invalidInputs(): boolean {
    try {
      if (this.genericComposeMode) {
        let validCompose=(   this.formData['templateName'].value != null && this.formData['templateName'].value.trim() != ''
                          && (this.hideSubject || (this.formData['subject'].value != null && this.formData['subject'].value.trim() != ''))
                          && this.formData['message'].value      != null && this.formData['message'].value.trim()      != ''
                         );

        if (validCompose)
          validCompose=this.getDodgySystemPlaceHolders(this.formData['message'].value)=="";

        if (validCompose && !this.hideSubject)
          validCompose=this.getDodgySystemPlaceHolders(this.formData['subject'].value)=="";

        return !validCompose;
      }

      let valid = (this.formData['templateName'].value != null && this.formData['templateName'].value.trim() != ''
              && this.formData['subject'].value != null && this.formData['subject'].value.trim() != '' && this.formData['message'].value != null && this.formData['message'].value.trim() != ''
              && ((this.formData['fromEmail'].value != null && this.formData['fromEmail'].value.trim() != '') || this.formData['useDefaultFromEmail'].value)
            );

      if (valid && (this.formData['sendElsewhere'].value)) {
        valid = (this.formData['toEmail'].value != null && this.formData['toEmail'].value.trim() != '') || (this.formData['useDefaultToEmail'].value && this.companyDefaults.toEmail != null && this.companyDefaults.toEmail != "");
      }

      if (!this.formData['sendToUser'].value && !this.formData['sendElsewhere'].value) {
        valid = false;
      }

      if (valid) {
        valid = this.getDodgySystemPlaceHolders(this.formData['message'].value) == "";
      }
      if (valid) {
        valid = this.getDodgySystemPlaceHolders(this.formData['subject'].value) == "";
      }
      return !valid;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return true;
    }
  }

  public getDodgySystemPlaceHolders(inputValue:string): string {
    let words: string[] = [];
    let dodgyPlaceHolders: string = "";

    if (inputValue != null) {
      words = inputValue
        .trim()
        .replace(/\,/," ")
        .replace(/@@/g," @@")
        .split(/\s+/); // Splits by one or more spaces
  
      words.forEach(word => { 
        if(word.startsWith('@@')) {
          if(!this.templateReplacements.some(p => word.startsWith(p.placeHolder ?? ""))) {
            dodgyPlaceHolders += ',' + word;
          }
        }
      });
  
      if (dodgyPlaceHolders != "") {
        dodgyPlaceHolders = dodgyPlaceHolders.substring(1,10000);
      }
    }

    return dodgyPlaceHolders;
  }

  public saveAsNew() {
    try {
      this.reflectChanges();
      this.templateFormSubmitted=true;

      if (this.templateForm.valid) {
        this.commConfigService.createCommunicationTemplate({
          AlertTypeId         : this.template.alertTypeId,
          ID                  : 0,
          CommunicationTypeId : this.template.communicationTypeId,
          CompanyId           : this.sureSimCompanyId,
          DeliveryTypeId      : DeliveryType.Email,
          MessageTypeId       : this.template.messageTypeId,
          Name                : this.template.name,
          Subject             : this.subjectForSave(),
          Body                : this.template.body,
          CC                  : this.template.cc,
          BCC                 : this.template.bcc,
          FromEmail           : this.template.fromEmail,
          FromNumber          : this.template.fromNumber,
          ToEmail             : this.template.toEmail,
          ToNumber            : this.template.toNumber,
          SendToUser          : this.template.sendToUser,
          SendElsewhere       : this.template.sendElsewhere,
          UseDefaultCC        : this.template.useDefaultCC,
          UseDefaultBCC       : this.template.useDefaultBCC,
          UseDefaultFromEmail : this.template.useDefaultFromEmail,
          UseDefaultFromNumber: this.template.useDefaultFromNumber,
          UseDefaultToEmail   : this.template.useDefaultToEmail,
          UseDefaultToNumber  : this.template.useDefaultToNumber,
          EnteredBy           : this.curUser.userId,
          Active              : true,
          Deleted             : false,
          SystemOwned         : false
        }).subscribe(id => {
          this.template.id         = id;
          this.templateModalAction = TemplateModalAction.Save;
          this.completedModalForm.openForm("Congratulations",  this.updateMessage != undefined ? this.updateMessage : "Template has been saved.");
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
